import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    StatTileDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../types";
import {
    concentric
} from "../../helpers/theme/concentric";
import {
    getCornerStyle
} from "../../helpers/theme/corner";

const stylesheet = StyleSheet.create({
    stat: {
        flexDirection: "column",
        minWidth: 0
    },
    trend: {
        overflow: "hidden"
    }
});

export const useStyles = ({
    isTrendFlush,
    shapeConfigs,
    radiuses,
    borders,
    spaces,
    inset
}: StatTileDynamicStyleType) => {
    const styles = {
        trendLine: {} as Mutable<ViewStyle>,
        trend: {} as Mutable<ViewStyle>,
        stat: {
            gap: spaces.spacingXs
        } as Mutable<ViewStyle>
    };

    if(!isTrendFlush) {
        return styles;
    }

    const edgeRadius = concentric({
        outer: radiuses.surface,
        role: radiuses.surface,
        inset: borders.line
    });

    const {
        borderRadius: scaledEdgeRadius,
        ...edgeShape
    } = getCornerStyle({
        radius: edgeRadius,
        shapeConfigs
    });

    Object.assign(styles.trend, {
        ...edgeShape,
        borderBottomStartRadius: scaledEdgeRadius,
        borderBottomEndRadius: scaledEdgeRadius,
        marginHorizontal: -inset,
        marginBottom: -inset
    });

    styles.trendLine.paddingEnd = spaces.spacingSm;

    return styles;
};
export default stylesheet;
